import Rate from './Rate'
export default Rate



// WEBPACK FOOTER //
// ./components/vc-rate/src/index.js